import { render } from "./ReportesVentasList.vue?vue&type=template&id=07d16f22&scoped=true"
import script from "./ReportesVentasList.vue?vue&type=script&lang=js"
export * from "./ReportesVentasList.vue?vue&type=script&lang=js"

import "./ReportesVentasList.vue?vue&type=style&index=0&id=07d16f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d16f22"]])

export default __exports__